import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export interface PinToEnterProps {
  name: string;
  pin: string;
}

export function PinToEnter(props: PinToEnterProps) {
  const { name, pin } = props;

  return (
    <Stack gap={3} alignItems="center">
      <Text variant="body1" color={(theme) => theme.palette.text.secondary}>
        {name}
      </Text>
      <Text color={(theme) => theme.palette.text.secondary} variant="h3" sx={{ fontWeight: 700 }}>
        {pin}
      </Text>
    </Stack>
  );
}
